import React from 'react';
import { motion } from "framer-motion";

const DeleteConfirmationModal = ({ itemType, onConfirm, onCancel }) => {
    return (
        <motion.div
            className="z-50 fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex justify-center items-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
        >
            <motion.div
                className="bg-white p-6 rounded-xl shadow-xl w-96"
                initial={{ scale: 0.9 }}
                animate={{ scale: 1 }}
            >
                <h3 className="text-xl font-bold text-gray-800 mb-4">Confirm Deletion</h3>
                <p className="mb-4">Are you sure you want to delete this {itemType.toLowerCase()}? This action cannot be undone.</p>
                
                <div className="flex justify-end space-x-3">
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 bg-gray-300 hover:bg-gray-400 text-gray-800 rounded-lg transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors"
                    >
                        Delete
                    </button>
                </div>
            </motion.div>
        </motion.div>
    );
};

export default DeleteConfirmationModal;